(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catpak-hero-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.chero').forEach(function(root){
    var track=root.querySelector('.chero__track');
    var slides=root.querySelectorAll('.chero__slide');
    var dots=root.querySelectorAll('.chero__dot');
    var n=slides.length; if(n<2){return;}
    var i=0, timer=null;
    var auto=root.dataset.autoplay==='true';
    var iv=parseInt(root.dataset.interval,10)||5000;
    function go(k){ i=(k+n)%n; track.style.transform='translateX('+(-i*100)+'%)';
      dots.forEach(function(d,x){d.classList.toggle('is-active',x===i);}); }
    function next(){go(i+1);}
    function start(){ if(auto){stop();timer=setInterval(next,iv);} }
    function stop(){ if(timer){clearInterval(timer);timer=null;} }
    root.querySelectorAll('.chero__arrow').forEach(function(b){ b.addEventListener('click',function(){ go(i+parseInt(b.dataset.dir,10)); start(); }); });
    dots.forEach(function(d){ d.addEventListener('click',function(){ go(parseInt(d.dataset.i,10)); start(); }); });
    root.addEventListener('mouseenter',stop); root.addEventListener('mouseleave',start);
    // swipe
    var x0=null;
    track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;stop();},{passive:true});
    track.addEventListener('touchend',function(e){ if(x0===null)return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40){go(i+(dx<0?1:-1));} x0=null; start(); },{passive:true});
    go(0); start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catpak-shop-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-catdrag]').forEach(function (row) {
    var bar = row.parentElement.querySelector('[data-catbar]');
    var thumb = bar ? bar.querySelector('.catpak-catgrid__thumb') : null;

    function updateBar() {
      if (!thumb) return;
      var wPct = Math.min(Math.max(row.clientWidth / row.scrollWidth * 100, 14), 100);
      thumb.style.width = wPct + '%';
      var max = row.scrollWidth - row.clientWidth;
      thumb.style.left = (max > 0 ? row.scrollLeft / max : 0) * (100 - wPct) + '%';
    }

    var down = false, moved = false, startX = 0, startLeft = 0;
    row.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startLeft = row.scrollLeft; });
    row.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - startX; if (Math.abs(dx) > 4) { moved = true; row.classList.add('is-dragging'); } row.scrollLeft = startLeft - dx; });
    function end() { down = false; setTimeout(function () { row.classList.remove('is-dragging'); }, 0); }
    row.addEventListener('mouseup', end);
    row.addEventListener('mouseleave', end);
    row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
    row.addEventListener('scroll', updateBar);
    window.addEventListener('resize', updateBar);

    if (thumb) {
      var tDown = false, tx = 0, tScroll = 0;
      function tMove(px) {
        var travel = bar.clientWidth - thumb.offsetWidth, max = row.scrollWidth - row.clientWidth;
        if (travel > 0) row.scrollLeft = tScroll + (px - tx) * (max / travel);
      }
      thumb.addEventListener('mousedown', function (e) { e.preventDefault(); e.stopPropagation(); tDown = true; tx = e.pageX; tScroll = row.scrollLeft; });
      document.addEventListener('mousemove', function (e) { if (tDown) tMove(e.pageX); });
      document.addEventListener('mouseup', function () { tDown = false; });
      thumb.addEventListener('touchstart', function (e) { tDown = true; tx = e.touches[0].pageX; tScroll = row.scrollLeft; });
      document.addEventListener('touchmove', function (e) { if (tDown) tMove(e.touches[0].pageX); });
      document.addEventListener('touchend', function () { tDown = false; });
    }

    updateBar();
    window.addEventListener('load', updateBar);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
